var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "generic-link",
    {
      staticClass: "nav-link login",
      attrs: { title: "User Login" },
      nativeOn: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.loginLinkClicked.apply(null, arguments)
        },
      },
    },
    [
      _c("login-svg-icons", { attrs: { name: "LoginIcon" } }),
      _vm._v(" "),
      _c("span", { staticClass: "nav-label" }, [_vm._v("\n    Login\n  ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }